import { ForwardToInboxOutlined } from '@mui/icons-material';
import { Avatar, Box, Button, Divider, Paper, PaperProps, Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styleVariables from '../../../../../app/styles/styleVariables';
import useInvestContactPicture from '../../../hooks/contact/useInvestContactPicture';
import IInvestContact from '../../../interfaces/contact/IInvestContact';
import investorContactLang from '../langs/investorContactLang';
import { langLookup } from '../../../../../app/utils/langLookup';

type CContactDrawerProps = PaperProps & {
	contacts: IInvestContact[];
};

const CContactDrawer = (props: CContactDrawerProps) => {
	const { contacts, ...otherProps } = props;

	return (
		<>
			{contacts ? (
				<Paper
					{...otherProps}
					sx={{ marginBottom: '20px', padding: '15px', backgroundColor: 'rgba(42, 189, 187, 0.15)' }}
				>
					{contacts.map((contact, index) => {
						return (
							<CContactDrawerItem
								key={index}
								contact={contact}
								showDivider={index < contacts.length - 1}
							/>
						);
					})}
				</Paper>
			) : (
				''
			)}
		</>
	);
};

type CContactDrawerItemProps = {
	contact: IInvestContact;
	showDivider?: boolean;
};

const CContactDrawerItem = (props: CContactDrawerItemProps) => {
	const { contact, showDivider } = props;
	const { t } = useTranslation();

	const picture = useInvestContactPicture(contact.pictureTag ?? '');

	const styles = {
		title: {
			fontWeight: '600',
			color: 'white',
		},
		identity: {
			padding: '0px 0px 0px 0px',
			fontSize: '15px',
			color: 'white',
			lineHeight: '1.5rem',
		},
	};
	return (
		<Box>
			<Typography sx={styles.title}>
				{contact.roleTag ? t(langLookup(investorContactLang, contact.roleTag)?.tag ?? '') : ''}
			</Typography>
			<Box sx={{ margin: '15px 0px 0px 0px' }}>
				<Stack direction="row" spacing={2} alignItems="center">
					<Avatar src={contact.picturePublicUrl ?? (picture ? picture.toString() : undefined)} />
					<Box sx={styles.identity}>
						<Box className="test">
							{contact.firstname} {contact.lastname?.toUpperCase()}
						</Box>
						<Box
							sx={{ cursor: 'pointer' }}
							onClick={(e) => {
								window.location.href = 'tel:' + contact.phone?.replace(/\s/g, '');
								e.preventDefault();
							}}
						>
							{contact.phone}
						</Box>
					</Box>
				</Stack>

				<Box>
					<Button
						onClick={(e) => {
							window.location.href = 'mailto:' + contact.email;
							e.preventDefault();
						}}
						startIcon={<ForwardToInboxOutlined sx={{ color: styleVariables.primaryColor }} />}
						variant="contained"
						color="inherit"
						sx={{
							color: '#1A2B48',
							marginTop: '15px',
							fontSize: '0.8rem',
							padding: '6px',
							width: '100%',
						}}
					>
						Send a message
					</Button>
				</Box>
			</Box>
			{showDivider ? <Divider sx={{ backgroundColor: 'white', margin: '15px 0px' }} /> : ''}
		</Box>
	);
};

export default CContactDrawer;
